export default {"src":"/_next/static/media/locationPinRedesign.ff8d72b4.svg","height":24,"width":24};